import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useCallback, useId, useRef, useEffect } from "react";
import { useMedia } from "react-use";
import { Overlay } from "../../../../Ui/Overlay";
import { getBreakpoint } from "../../../../Theme";
import { TooltipWrapper, TooltipContent } from "./Tooltip.styles";
var Tooltip = function(param) {
    var content = param.content, trigger = param.trigger, title = param.title, _width = param.width, width = _width === void 0 ? "default" : _width;
    var ref = useState(false), showModal = ref[0], setShowModal = ref[1];
    var id = "tooltip-content-".concat(useId());
    var ref1 = useRef(null);
    var ref2 = useState(0), offset = ref2[0], setOffset = ref2[1];
    var isMobile = useMedia("(max-width: ".concat(getBreakpoint("lg"), "px)"), false);
    useEffect(function() {
        var ref;
        var value = ((ref = ref1.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0;
        setOffset(Math.round(value / 2));
    }, []);
    var handleShowModal = useCallback(function(event) {
        event.stopPropagation();
        if (isMobile) {
            setShowModal(true);
        }
    }, [
        isMobile
    ]);
    var handleHideModal = function() {
        setShowModal(false);
    };
    return /*#__PURE__*/ _jsxs(TooltipWrapper, {
        "aria-describedby": id,
        hover: !isMobile,
        onClick: handleShowModal,
        ref: ref1,
        children: [
            trigger,
            showModal ? // Modal view on mobile
            /*#__PURE__*/ _jsx(Overlay, {
                open: showModal,
                title: title,
                onClose: handleHideModal,
                children: content
            }) : // Tooltip Overlay on desktop
            /*#__PURE__*/ _jsx(TooltipContent, {
                role: "tooltip",
                id: id,
                $width: width,
                $offset: offset,
                children: content
            })
        ]
    });
};
export { Tooltip };
